import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import classnames from "classnames";

// components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    Spinner,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane
} from "reactstrap";
import { faAddressCard, faFile, faUserLock, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from 'react-select'

// style
import "../../../assets/css/loading.css";

// helpers
import { InputCEP, InputCPF, InputTELEFONE } from "../../../helpers/mask.js";
import { formateDateApi } from "../../../helpers/formats.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_GETExternal, api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

import Funcionalidades from "../../../views/admin/seguranca/Funcionalidades.jsx"

export default function UsuariosForm({ history, handleReturn, item }) {
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, clearErrors, setValue } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    //state para pegar as permissoes dos relatorio do usuário
    const [permissoesRelatorio, setPermissoesRelatorio] = useState([]);

    // Perfil
    const [optionsPerfil, setOptionsPerfil] = useState([]);
    const [perfil, setPerfil] = useState("");
    const loadOptionsPerfil = () => {
        let listaperfis = [];
        if (session.perfil == "Gestor") {
            listaperfis.push({ value: 'Gestor', label: 'Gestor' });
            listaperfis.push({ value: 'Adm', label: 'Adm Concessionária' });
            listaperfis.push({ value: 'Encarregado de Monitoramento', label: 'Encarregado de Monitoramento' });
            listaperfis.push({ value: 'Fiscal', label: 'Fiscal' });
        }
        else if (session.perfil == "Adm") {
            listaperfis.push({ value: 'Adm', label: 'Adm Concessionária' });
            listaperfis.push({ value: 'Operador de Coleta', label: 'Operador de Coleta' });
            listaperfis.push({ value: 'Supervisor', label: 'Supervisor' });
        }
        else if (session.perfil == "Master") {
            listaperfis.push({ value: 'Gestor', label: 'Gestor' });
            listaperfis.push({ value: 'Adm', label: 'Adm Concessionária' });
            listaperfis.push({ value: 'Encarregado de Monitoramento', label: 'Encarregado de Monitoramento' });
            listaperfis.push({ value: 'Fiscal', label: 'Fiscal' });
            listaperfis.push({ value: 'Operador de Coleta', label: 'Operador de Coleta' });
            listaperfis.push({ value: 'Supervisor', label: 'Supervisor' });
        }
        setOptionsPerfil(listaperfis);
    }

    // Concessionária
    const [optionsConcessionaria, setOptionsConcessionaria] = useState([]);
    const [concessionaria, setConcessionaria] = useState(null);
    const loadOptionsConcessionaria = () => {
        api_GET(`concessionaria`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsConcessionaria(result.data);
                if (session.concessionariaId != null)
                    setConcessionaria(result.data.filter(f => f.concessionariaId == session.concessionariaId)[0]);
            }
        });
    }
    const handleConcessionaria = event => {
        let value = event;
        setConcessionaria(value);
        clearErrors("concessionaria");

        setModalidadesColeta([]);
        loadOptionsModalidadesColeta(value.concessionariaId);
    }
    useEffect(() => {
        if (concessionaria != null)
            loadOptionsVeiculo(concessionaria.concessionariaId);
    }, [concessionaria]);

    // Status
    const options_status = [
        { value: 'Ativo', label: 'Ativo' },
        { value: 'Inativo', label: 'Inativo' }
    ];
    const [status, setStatus] = useState("");

    // CPF
    const [cpf, setCPF] = useState("");
    const handleCPF = (event) => {
        setCPF(event.target.value);
        clearErrors("cpf");
    }

    // Telefone
    const [telefone, setTelefone] = useState("");
    const handleTelefone = (event) => {
        setTelefone(event.target.value);
        clearErrors("telefone");
    }

    // Veiculo
    const [optionsVeiculo, setOptionsVeiculo] = useState([]);
    const [veiculo, setVeiculo] = useState(null);
    const loadOptionsVeiculo = (concessionariaId) => {
        api_GET(`veiculo/GetByConcessionaria/${concessionariaId}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let veiculos = [];
                veiculos.push({ veiculoId: null, placa: "Nenhum" });
                result.data.map(v => veiculos.push(v));
                setOptionsVeiculo(veiculos);
            }
        });
    }
    const handleVeiculoChange = event => {
        let value = event;
        setVeiculo(value);
        clearErrors("veiculo");
    }

    // CEP
    const [cep, setCep] = useState("");
    const handleCEP = (event) => {
        clearErrors("cep");
        setCep(event.target.value.replace("-", ""));

        if (event.target.value.length != 9)
            return;

        api_GETExternal(`https://viacep.com.br/ws/${event.target.value.replace("-", "")}/json/`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("cidade", "");
                setValue("uf", "");
            }
            else {
                setValue("logradouro", result.data.logradouro);
                setValue("bairro", result.data.bairro);
                setValue("cidade", result.data.localidade);
                setValue("uf", result.data.uf);
            }
        });
    }

    // Modalidade 
    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
    const [modalidadesColeta, setModalidadesColeta] = useState([]);
    const loadOptionsModalidadesColeta = (concessionariaId) => {
        api_GET(`modalidadeColeta/GetByConcessionaria/${concessionariaId}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setoptionsModalidadesColeta(result.data);
            }
        });
    }
    const handleModalidadesColeta = event => {
        let value = event;
        let lstSelect = [];
        value.map(item => {
            lstSelect.push({
                veiculoId: item == null ? 0 : item.veiculoId,
                modalidadeColetaId: item.modalidadeColetaId
            });
        });
        setModalidadesColeta(lstSelect);
    }

    // Outras opções
    const options_prestador_servico = [
        { value: 'true', label: 'Sim' },
        { value: 'false', label: 'Não' }
    ];
    const [prestadorServico, setPrestadorServico] = useState(null);


    // Submit
    const [usuarioId, setUsuarioId] = useState(null);
    const onSubmit = (data) => {
        if (concessionaria == "") {
            setError("concessionaria");
            return;
        }

        if (status == "") {
            setError("status");
            return;
        }

        if ((perfil == "Adm" || perfil == "Operador de Coleta" || perfil == "Supervisor") && concessionaria == null) {
            setError("concessionaria");
            return;
        }

        let json_submit = {
            usuarioId: item == null ? 0 : item.usuarioId,
            nome: data.nome,
            perfil: perfil,
            ativo: status == "Ativo" ? true : false,
            login: data.login,
            email: data.email,
            cpf: cpf,
            cnh: data.cnh,
            validadeCNH: data.validade_cnh == "" ? null : formateDateApi(data.validade_cnh),
            telefone: telefone,
            cep: cep,
            logradouro: data.logradouro,
            numeroLogradouro: data.numero,
            complemento: data.complemento,
            bairro: data.bairro,
            cidade: data.cidade,
            uf: data.uf,
            veiculoId: veiculo != null ? veiculo.veiculoId : null,
            concessionariaId: concessionaria != null ? concessionaria.concessionariaId : null,
            acessaAppColetor: perfil == "Operador de Coleta" ? true : false,
            prestadorServico: prestadorServico,
            usuarioModalidadeColeta: modalidadesColeta
        }

        setshowLoading(true);
        if (json_submit.usuarioId == 0) {
            api_POST('usuario', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        setUsuarioId(result.data.usuarioId);
                    });
                }
            });
        }
        else {
            api_PUT('usuario', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        setUsuarioId(result.data.usuarioId);
                    });
                }
            });
        }
    };

    // Permissoes de Acesso
    const [permissoesAcesso, setpermissoesAcesso] = useState([]);
    const handleUsuarioPermissaoAcessoClick = (event) => {
        const data = event.target;
        let permissoes = permissoesAcesso;
        if (data.checked && permissoes.filter(f => f == data.name).length == 0)
            permissoes.push(data.name);
        else
            permissoes = permissoesAcesso.filter(f => f != data.name);

        setpermissoesAcesso(permissoes);
    }
    const PutUsuarioPermissoesAcesso = () => {
        let json_post = [];
        permissoesAcesso.map(m => {
            json_post.push({ permissao: m });
        });

        api_PUT(`usuario/AtualizaPermissoesAcesso/${usuarioId}`, json_post).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                });
            }
        });
    }

    // Permissoes Especiais
    const [permissoesEspeciais, setpermissoesEspeciais] = useState([]);
    const handleUsuarioPermissaoEspecialClick = (event) => {
        const data = event.target;
        let permissoes = permissoesEspeciais;
        if (data.checked && permissoes.filter(f => f == data.name).length == 0)
            permissoes.push(data.name);
        else
            permissoes = permissoesEspeciais.filter(f => f != data.name);

        setpermissoesEspeciais(permissoes);
    }
    const PutUsuarioPermissoesEspeciais = () => {
        let json_post = [];
        permissoesEspeciais.map(m => {
            json_post.push({ permissao: m });
        });

        api_PUT(`usuario/AtualizaPermissoesEspeciais/${usuarioId}`, json_post).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                });
            }
        });
    }

    const loadOptionsModalidadesSemConcessionaria = () => {
        api_GET(`modalidadeColeta/GetListAtivas`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setoptionsModalidadesColeta(result.data);
            }
        });
    }

    // Load item
    useEffect(() => {
        loadOptionsConcessionaria();
        loadOptionsPerfil();
        setPerfil(item != null ? item.perfil : null);
        loadOptionsModalidadesSemConcessionaria();

        setTimeout(function () {
            setValue("nome", item == null ? "" : item.nome);
            setValue("login", item == null ? "" : item.login);
            setValue("email", item == null ? "" : item.email);
            setValue("cnh", item == null ? "" : item.cnh);
            setValue("validade_cnh", item == null ? "" : formateDateApi(item.validadeCNH));
            setValue("cep", item == null ? "" : item.cep);
            setValue("logradouro", item == null ? "" : item.logradouro);
            setValue("complemento", item == null ? "" : item.complemento);
            setValue("numero", item == null ? "" : item.numeroLogradouro);
            setValue("bairro", item == null ? "" : item.bairro);
            setValue("cidade", item == null ? "" : item.cidade);
            setValue("uf", item == null ? "" : item.uf);
            if (item != null) {
                setUsuarioId(item.usuarioId);
                setStatus((item.ativo ? "Ativo" : "Inativo"));
                setCPF(item.cpf);
                setTelefone(item.telefone);
                setCep(item.cep);
                setPrestadorServico((item.prestadorServico ? "true" : "false"));

                if (item.usuarioModalidadeColeta != null && item.usuarioModalidadeColeta.length > 0)
                    setModalidadesColeta(item.usuarioModalidadeColeta);

                if (item.veiculo != null)
                    setVeiculo(item.veiculo);

                if (item.concessionaria != null) {
                    setConcessionaria(item.concessionaria);
                    loadOptionsModalidadesColeta(item.concessionaria.concessionariaId);
                }

                if (item.usuarioPermissaoAcesso != null) {
                    let permissoes = [];
                    item.usuarioPermissaoAcesso.map(m => { permissoes.push(m.permissao) });
                    setpermissoesAcesso(permissoes);
                }

                if (item.usuarioPermissaoEspecial != null) {
                    let permissoespesciais = [];
                    item.usuarioPermissaoEspecial.map(m => { permissoespesciais.push(m.permissao) });
                    setpermissoesEspeciais(permissoespesciais);
                }
                if (item.usuarioPermissaoRelatorios?.length > 0) {
                    let permissoesRelatorios = [];
                    item.usuarioPermissaoRelatorios.map(m => { permissoesRelatorios.push(m.permissao) })
                    setPermissoesRelatorio(permissoesRelatorios);
                }
            }
        }, 0.5)
    }, [item]);

    // Tabs
    const [tab, setTab] = useState(1);
    const toggleNavs = (e, state, index) => {
        if (usuarioId == null && index != 1) {
            showMessage("Atenção", "Para liberar as permissoes é necessário salvar a ficha do usuário", 'warning', null);
            return;
        }

        e.preventDefault();
        setTab(index);
    };

    const handleUsuarioPermissaoRelatorioClick = (event) => {
        const data = event.target;
        let permissoes = permissoesRelatorio;
        if (data.checked && permissoes.filter(f => f == data.name).length == 0)
            permissoes.push(data.name);
        else
            permissoes = permissoesRelatorio.filter(f => f != data.name);

        setPermissoesRelatorio(permissoes);
    }

    const PutUsuarioPermissoesRelatorios = () => {
        let json_post = [];
        permissoesRelatorio.map(m => {
            json_post.push({ permissao: m });
        });

        api_PUT(`usuario/AtualizaPermissoesRelatorios/${usuarioId}`, json_post).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { setPermissoesRelatorio(result.data) });
            }
        });
    }

    return (
        <>
            <div>
                {showLoading &&
                    <div className="carregandoCmp">
                        <div className="box">
                            <label style={{ marginRight: "20px" }}>Carregando...</label>
                            <Spinner size="sm" color="info" />
                        </div>
                    </div>
                }
                <Row>
                    <Container fluid>
                        <Card className="shadow">

                            <CardHeader className="border-0">
                                <strong> Cadastro de Usuário</strong>
                            </CardHeader>
                            <CardBody>
                                <div className="nav-wrapper mb-2">
                                    <Nav
                                        className="nav-fill flex-column flex-md-row"
                                        id="tabs-icons-text"
                                        pills
                                        role="tablist"
                                    >
                                        <NavItem>
                                            <NavLink
                                                aria-selected={tab === 1}
                                                className={classnames("mb-sm-3 mb-md-0", {
                                                    active: tab === 1
                                                })}
                                                onClick={e => toggleNavs(e, "tabs", 1)}
                                                role="tab"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <FontAwesomeIcon icon={faAddressCard} />
                                                &nbsp;&nbsp;Ficha
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                aria-selected={tab === 2}
                                                className={classnames("mb-sm-3 mb-md-0", {
                                                    active: tab === 2
                                                })}
                                                onClick={e => toggleNavs(e, "tabs", 2)}
                                                role="tab"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <FontAwesomeIcon icon={faUserLock} />
                                                &nbsp;&nbsp;Permissões de Acesso
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                aria-selected={tab === 3}
                                                className={classnames("mb-sm-3 mb-md-0", {
                                                    active: tab === 3
                                                })}
                                                onClick={e => toggleNavs(e, "tabs", 3)}
                                                role="tab"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <FontAwesomeIcon icon={faUserShield} />
                                                &nbsp;&nbsp;Permissões Especiais
                                            </NavLink>
                                        </NavItem>
                                        {(perfil == "Adm" || perfil == "Gestor") &&
                                            <NavItem>
                                                <NavLink
                                                    aria-selected={tab === 4}
                                                    className={classnames("mb-sm-3 mb-md-0", {
                                                        active: tab === 4
                                                    })}
                                                    onClick={e => toggleNavs(e, "tabs", 4)}
                                                    role="tab"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <FontAwesomeIcon icon={faFile} />
                                                    &nbsp;&nbsp;Relatórios
                                                </NavLink>
                                            </NavItem>
                                        }
                                    </Nav>
                                </div>
                                <TabContent activeTab={"tabs" + tab}>
                                    <TabPane tabId="tabs1">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <Row>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-address" >
                                                            * Nome
                                                        </label>
                                                        <Input
                                                            name="nome"
                                                            placeholder="Nome"
                                                            type="text"
                                                            maxLength={150}
                                                            innerRef={register({ required: true })}
                                                        />
                                                        {errors.nome && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-address" >
                                                            * Perfil
                                                        </label>
                                                        <Select
                                                            options={optionsPerfil}
                                                            name="perfil"
                                                            onChange={(e) => { setPerfil(e.value) }}
                                                            value={optionsPerfil.find(obj => obj.value === perfil)}
                                                            placeholder="Selecione"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-address" >
                                                            * Status
                                                        </label>
                                                        <Select
                                                            options={options_status}
                                                            name="status"
                                                            onChange={(e) => { setStatus(e.value) }}
                                                            value={options_status.find(obj => obj.value === status)}
                                                            placeholder="Selecione"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-address" >
                                                            * Login
                                                        </label>
                                                        <Input
                                                            name="login"
                                                            placeholder="Login"
                                                            type="text"
                                                            maxLength={150}
                                                            innerRef={register({ required: true })}
                                                        />
                                                        {errors.login && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                </Col>
                                                <Col md="6" lg="3">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-address" >
                                                            * Telefone
                                                        </label>
                                                        <InputTELEFONE
                                                            name="telefone"
                                                            placeholder="Telefone"
                                                            value={telefone}
                                                            onChange={handleTelefone}
                                                            inputRef={register({ required: true })}
                                                        />
                                                        {errors.telefone && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                </Col>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-address" >
                                                            * Email
                                                        </label>
                                                        <Input
                                                            name="email"
                                                            placeholder="Email"
                                                            type="email"
                                                            maxLength={150}
                                                            innerRef={register({ required: true })}
                                                        />
                                                        {errors.email && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                </Col>
                                                {(session.concessionariaId == null && (perfil == "Adm" || perfil == "Operador de Coleta" || perfil == "Supervisor")) &&
                                                    <Col md="6" lg="6">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                * Concessionária
                                                            </label>
                                                            <Select
                                                                options={optionsConcessionaria}
                                                                name="concessionaria"
                                                                getOptionLabel={({ identificacao }) => identificacao}
                                                                getOptionValue={({ concessionariaId }) => concessionariaId}
                                                                onChange={(value) => { handleConcessionaria(value) }}
                                                                value={concessionaria != null && optionsConcessionaria.find(obj => obj.concessionariaId === concessionaria.concessionariaId)}
                                                                placeholder="Selecione"

                                                            />
                                                            {errors.concessionaria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                        </FormGroup>
                                                    </Col>
                                                }
                                                {!!perfil && perfil != "Operador de Coleta" &&
                                                    <Col md="6" lg="12">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                * Modalidade de Serviço
                                                            </label>
                                                            <Select
                                                                options={optionsModalidadesColeta}
                                                                name="modalidadeColeta"
                                                                getOptionLabel={({ descricao }) => descricao}
                                                                getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                                                onChange={(value) => { handleModalidadesColeta(value || []) }}
                                                                value={optionsModalidadesColeta.filter(({ modalidadeColetaId }) => modalidadesColeta != null && modalidadesColeta.filter(f => f.modalidadeColetaId == modalidadeColetaId).length > 0)}
                                                                placeholder="Selecione"
                                                                isMulti="true"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                }

                                            </Row>
                                            <br />
                                            {(perfil == "Operador de Coleta" || perfil == "Supervisor") &&
                                                <h3>Informações Adicionais</h3>
                                            }
                                            <br /><br />
                                            <Row>
                                                {(perfil == "Operador de Coleta" || perfil == "Supervisor") &&
                                                    <Col md="6" lg="3">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                * CPF
                                                            </label>
                                                            <InputCPF
                                                                name="cpf"
                                                                placeholder="CPF"
                                                                value={cpf}
                                                                maxLength={14}
                                                                onChange={handleCPF}
                                                                inputRef={register({ required: true })}
                                                            />
                                                            {errors.cpf && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                        </FormGroup>
                                                    </Col>
                                                }
                                                {perfil == "Operador de Coleta" &&
                                                    <Col md="6" lg="3">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                CNH
                                                            </label>
                                                            <Input
                                                                name="cnh"
                                                                placeholder="CNH"
                                                                type="text"
                                                                maxLength={20}
                                                                innerRef={register()}
                                                            />
                                                            {errors.cnh && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                        </FormGroup>
                                                    </Col>
                                                }
                                                {perfil == "Operador de Coleta" &&
                                                    <Col md="6" lg="3">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                Validade CNH
                                                            </label>
                                                            <Input
                                                                defaultValue=""
                                                                name="validade_cnh"
                                                                placeholder="Validade CNH"
                                                                type="date"
                                                                innerRef={register()}
                                                            />
                                                            {errors.validade_cnh && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                        </FormGroup>
                                                    </Col>
                                                }
                                            </Row>
                                            {perfil == "Operador de Coleta" &&
                                                <Row>
                                                    <Col md="4" lg="2">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                CEP
                                                            </label>
                                                            <InputCEP
                                                                name="cep"
                                                                placeholder="Cep"
                                                                value={cep}
                                                                onChange={handleCEP}
                                                                inputRef={register()}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="8" lg="6">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                Logradouro
                                                            </label>
                                                            <Input
                                                                name="logradouro"
                                                                placeholder="Logradouro"
                                                                type="text"
                                                                disabled="disabled"
                                                                innerRef={register()}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4" lg="2">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                Número
                                                            </label>
                                                            <Input
                                                                name="numero"
                                                                placeholder="Número"
                                                                type="number"
                                                                innerRef={register()}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4" lg="2">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                Complemento
                                                            </label>
                                                            <Input
                                                                name="complemento"
                                                                placeholder="Complemento"
                                                                type="text"
                                                                maxLength={30}
                                                                innerRef={register()}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4" lg="5">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                Bairro
                                                            </label>
                                                            <Input
                                                                name="bairro"
                                                                placeholder="Bairro"
                                                                type="text"
                                                                disabled="disabled"
                                                                innerRef={register()}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4" lg="5">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                Cidade
                                                            </label>
                                                            <Input
                                                                name="cidade"
                                                                placeholder="cidade"
                                                                type="text"
                                                                disabled="disabled"
                                                                innerRef={register()}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4" lg="2">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                UF
                                                            </label>
                                                            <Input
                                                                name="uf"
                                                                placeholder="uf"
                                                                type="text"
                                                                disabled="disabled"
                                                                innerRef={register()}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            }
                                            <Row>
                                                {perfil == "Operador de Coleta" &&
                                                    <Col md="6" lg="4">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                Recurso
                                                            </label>
                                                            <Select
                                                                name="veiculo"
                                                                options={optionsVeiculo}
                                                                getOptionLabel={({ placa }) => placa}
                                                                getOptionValue={({ veiculoId }) => veiculoId}
                                                                onChange={(value) => { handleVeiculoChange(value) }}
                                                                value={veiculo != null && optionsVeiculo.find(obj => obj.veiculoId === veiculo.veiculoId)}
                                                                placeholder="Nenhum"
                                                            />
                                                            {errors.veiculo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                        </FormGroup>
                                                    </Col>
                                                }
                                                {perfil == "Operador de Coleta" &&
                                                    <Col md="6" lg="4">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-address" >
                                                                Prestador de Serviço
                                                            </label>
                                                            <Select
                                                                options={options_prestador_servico}
                                                                name="prestador_servico"
                                                                onChange={(e) => { setPrestadorServico(e.value) }}
                                                                value={options_prestador_servico.find(obj => obj.value == prestadorServico)}
                                                                placeholder="Selecione"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                }
                                            </Row>

                                            <Row>
                                                <Col md="12" className="text-center">
                                                    <FormGroup>
                                                        <Button color="warning" type="button" onClick={() => { handleReturn() }}>Voltar</Button>
                                                        <Button color="success">Salvar Ficha</Button>
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                        </form>
                                    </TabPane>
                                    <TabPane tabId="tabs2">
                                        <Row>
                                            {perfil != null && Funcionalidades.filter((funcionalidade) => funcionalidade.Perfil == perfil).length > 0
                                                && Funcionalidades.filter((funcionalidade) => funcionalidade.Perfil == perfil)[0].Permissoes.map((funcionalidade) => (
                                                    <Col xs={12} sm={6} md={4} key={funcionalidade.path}>
                                                        <div className="custom-control custom-checkbox">
                                                            <input
                                                                className="custom-control-input"
                                                                id={funcionalidade.path}
                                                                name={funcionalidade.path}
                                                                type="checkbox"
                                                                defaultChecked={item != null && item.usuarioPermissaoAcesso != null
                                                                    && item.usuarioPermissaoAcesso.filter(f => f.permissao == funcionalidade.path).length > 0 ? true : false}
                                                                onClick={(e) => handleUsuarioPermissaoAcessoClick(e)}
                                                            />
                                                            <label className="custom-control-label" htmlFor={funcionalidade.path}>
                                                                {funcionalidade.name}
                                                            </label>
                                                        </div>
                                                    </Col>
                                                ))
                                            }
                                        </Row>
                                        <Row className="mt-4">
                                            <Col md="12" className="text-center">
                                                <FormGroup>
                                                    <Button color="warning" type="button" onClick={() => { handleReturn() }}>Voltar</Button>
                                                    <Button color="success" type="button" onClick={() => PutUsuarioPermissoesAcesso()}>Salvar Permissões de Acesso</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="tabs3">
                                        <Row>
                                            {perfil != null && Funcionalidades.filter((funcionalidade) => funcionalidade.Perfil == perfil).length > 0
                                                && Funcionalidades.filter((funcionalidade) => funcionalidade.Perfil == perfil)[0].PermissoesEspeciais.map((funcionalidade) => (
                                                    <Col xs={12} sm={6} md={4} key={funcionalidade.permissao}>
                                                        <div className="custom-control custom-checkbox">
                                                            <input
                                                                className="custom-control-input"
                                                                id={funcionalidade.permissao}
                                                                name={funcionalidade.permissao}
                                                                type="checkbox"
                                                                defaultChecked={item != null && item.usuarioPermissaoEspecial != null
                                                                    && item.usuarioPermissaoEspecial.filter(f => f.permissao == funcionalidade.permissao).length > 0 ? true : false}
                                                                onClick={(e) => handleUsuarioPermissaoEspecialClick(e)}
                                                            />
                                                            <label className="custom-control-label" htmlFor={funcionalidade.permissao}>
                                                                {funcionalidade.name}
                                                            </label>
                                                        </div>
                                                    </Col>
                                                ))
                                            }
                                        </Row>
                                        <Row>
                                            <Col md="12" className="text-center">
                                                <FormGroup>
                                                    <Button color="warning" type="button" onClick={() => { handleReturn() }}>Voltar</Button>
                                                    <Button color="success" type="button" onClick={() => PutUsuarioPermissoesEspeciais()}>Salvar Permissões Especiais</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="tabs4">
                                        <Row>
                                            {perfil != null &&
                                                Funcionalidades.filter((funcionalidade) => funcionalidade.Perfil == perfil).length > 0 &&
                                                Funcionalidades.filter((funcionalidade) => funcionalidade.Perfil == perfil)[0]?.Relatorios?.map((relatorio) => (
                                                    <Col xs={12} sm={6} md={4} key={relatorio.permissao}>
                                                        <div className="custom-control custom-checkbox">
                                                            <input
                                                                className="custom-control-input"
                                                                id={relatorio.permissao}
                                                                name={relatorio.permissao}
                                                                type="checkbox"
                                                                defaultChecked={item != null && item.usuarioPermissaoRelatorios != null
                                                                    && item.usuarioPermissaoRelatorios.filter(f => f.permissao == relatorio.permissao).length > 0 ? true : false}
                                                                onChange={(e) => handleUsuarioPermissaoRelatorioClick(e)}
                                                            />
                                                            <label className="custom-control-label" htmlFor={relatorio.permissao}>
                                                                {relatorio.name}
                                                            </label>
                                                        </div>
                                                    </Col>
                                                ))
                                            }

                                        </Row>
                                        <Row className="mt-1">
                                            <Col md="12" className="text-center">
                                                <FormGroup>
                                                    <Button color="warning" type="button" onClick={() => { handleReturn() }}>Voltar</Button>
                                                    <Button color="success" type="button" onClick={() => PutUsuarioPermissoesRelatorios()}>Salvar Permissões Relatório</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Container>
                </Row>
            </div>
        </>
    );
}
